fromOptimisticTransaction